import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconAlignRight = ({ t, className, height, width, fill }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 25 25'>
    <defs>
      <path id='a' d='M0 0h25v25H0z' />
    </defs>
    <g fill='none'>
      <mask id='b' fill='#fff'>
        <use />
      </mask>
      <use fill='#FFF' />
      <g mask='url(#b)'>
        <path d='M4 4h18v18H4z' />
        <path fill={fill} d='M9.625 18.625h11.25v2.25H9.625v-2.25zm-4.5-4.5h15.75v2.25H5.125v-2.25zm4.5-4.5h11.25v2.25H9.625v-2.25zm-4.5-4.5h15.75v2.25H5.125v-2.25z'
        />
      </g>
    </g>
  </svg>
)

export default Icon(IconAlignRight)
